import React, { useEffect, useState } from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { connect } from "react-redux";
import { setOrders, updateOrder } from "../../actions/order";
import { fetchApi } from "../../api";
import { STYLES } from "../../assets/styles";
import Container from "../../components/Container";
import CustomIcon from "../../components/CustomIcon";
import Header from "../../components/Header";
import ListItems from "../../components/ListItems";
import Loading from "../../components/Loading";
import Review from "../../components/Review";

function Orders({ setOrders, orders = [], navigation, updateOrder }) {
  const [isReady, setIsReady] = useState(false);
  const [refreshing, setRefreshing] = useState(false);

  const fetchOrders = (callback) => {
    fetchApi({
      path: "/orders",
    }).then((res) => {
      if (res.results) {
        setOrders(res.results);
        callback();
      } else {
        callback(res);
      }
    });
  };

  useEffect(() => {
    fetchOrders(() => {
      setIsReady(true);
    });
  }, []);

  const onRefresh = () => {
    setRefreshing(true);
    fetchOrders(() => {
      setRefreshing();
    });
  };
  const Item = ({ items, is_delivered, _id, review = {} }) => (
    <TouchableOpacity
      onPress={() =>
        navigation.navigate("orders", { screen: "order", params: { id: _id } })
      }
    >
      <View style={{ flexDirection: "row", borderBottomWidth: 1, padding: 15 }}>
        <View
          style={{
            flexDirection: "row",
            width: 70,
            height: 60,
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          {items.map(({ image_url }, index) => (
            <Image
              key={index + "i"}
              source={{ uri: image_url }}
              resizeMode="contain"
              style={{
                width: 60,
                height: 60,
                position: "absolute",
                left: index * 10,
                zIndex: -index,
              }}
            />
          ))}
        </View>
        <View style={{ padding: 5, justifyContent: "space-between", flex: 1 }}>
          {items.length > 1 ? (
            <>
              <Text style={{ fontWeight: "bold" }}>
                {is_delivered ? "Items Delivered" : "Items to be Delivered"}
              </Text>
              <Text>{`${items.length} Ordered Items`}</Text>
            </>
          ) : (
            <>
              <Text style={{ fontWeight: "bold" }}>
                {is_delivered ? "Item Delivered" : "Item to be Delivered"}
              </Text>
              <Text>{items[0].title}</Text>
            </>
          )}
          {is_delivered ? (
            <Review
              orderId={_id}
              prevReview={review}
              onReviewed={(review) => {
                updateOrder({ id: _id, data: review });
              }}
            />
          ) : null}
        </View>
        <CustomIcon
          type="AntDesign"
          name="right"
          style={{ fontSize: STYLES.fontSizes.small, alignSelf: "center" }}
        />
      </View>
    </TouchableOpacity>
  );

  return (
    <Container>
      <Header
        title="My Orders"
        rightIcons={[]}
        backButton
        navigation={navigation}
      />
      {isReady ? (
        <ListItems
          empty={{
            text: "No Item in your Order list",
          }}
          data={orders}
          renderItem={(item, index) => <Item key={index + "o"} {...item} />}
          refresh={true}
          refreshing={refreshing}
          onRefresh={onRefresh}
        />
      ) : (
        <Loading model={true} />
      )}
    </Container>
  );
}

const mapStateToProps = (state) => ({
  orders: state.order.items,
});

const mapDispatchToProps = (dispatch) => ({
  setOrders: (data) => dispatch(setOrders(data)),
  updateOrder: (data) => dispatch(updateOrder(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Orders);
